/**
 * Rounds down a number to the nearest multiple of the given multiple.
 */
export function roundDownToNearestMultiple(value: number, multiple: number): number {
  return Math.max(Math.floor(value / multiple) * multiple, multiple);
}
